export var component

export function init(comp) {
  console.log("$Z version 1.0.0")
  component=comp
  component.$Z=this
  //component.window=window
  //component.self=component
  //component.console=console
  //component.alert=alert
}

export function getTime() {
  return new Date();
}

export function sayHello(){
  return "Hello"
}

export function handleEvent(component, eventName, eventData){
  eval("var event=" + component[eventName] + "\n event(component, eventData)")
}

export function getRoot(){
    return document.getElementById("app").__vue__
}

export function getComponentName(){
  //console.log("2")
  //console.log("component",component)
  //console.log("name",component.$options.name)
  let name=component.$options.name
  return name
}

export function getSiblings(comp){
  if(!comp) comp=component
  let siblings=[]
  let parent=getParent(comp)
  if(!parent) return
  try{
    parent.getChildren().forEach(function(elem){
        if(elem!=comp) siblings.push(elem)
      })
    }catch(err){}
  return siblings
}

export function getSiblingIds(comp){
  if(!comp) comp=component
  let siblings=[]
  let parent=getParent(comp)
  if(!parent) return
  try{
    parent.getChildren().forEach(function(elem){
        if(elem!=comp) siblings.push(elem.id)
    })
  }catch(err){}
  return siblings
}

export function getApp(comp, appId){
    //return app with given appId
    if(!comp) comp=component
    let siblings=getSiblings(comp)
    try{
        return siblings.find(comp=> comp.id==appId)
    }catch(err){}
}

export function getParent(comp){
  if(!comp) comp=component
  let parent=null
  let elem=comp.$el
  //console.log("getParent elem",elem)
  if(!elem) {
    //console.log("getParent returning body: ", elem)
    return document.body
  }

  let i=0
  //console.log("15")

  while(parent==null){
      i++
      if(i>100) return
      //console.log("elem",elem)
      elem=elem.parentNode
      //console.log("getParent elem 2",elem)
      if(!elem) return document.body
      if(elem==document.body) return document.body
      //if(elem.className=="layoutWrapper") {
      if(elem.classList.contains("layoutWrapper")) {
        //console.log("getParent layoutWrapper",elem.__vue__)
        return elem.__vue__
      }
      parent=elem.__vue__
      if(parent){
          if(!parent.id) parent=null
      }

  }
  //console.log("count",i)
  if(!parent) parent=document.body
  //console.log("getParent",parent)
  return parent
}
  export function getFullPath(comp){
      let self=component
      if(!comp) comp=self
      let path=comp.id
      let i=0
      if(!path) path=getComponentName()
      //{
      //    path=self.$vnode.tag.split("-")
      //    path=path[path.length-1]
      //}
      //console.log(path)
      let parent=getParent(comp)
      while(parent!=document.body){
          i++
          if(i>100) return
          path=parent.id + "." + path
          parent=getParent(parent)
      }
      return "Root." + path
  }

/*
export function getParent(){
//console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@")
  let parent=null
  var el=component.$el.parentNode
  while(!parent){
    if(!el) break
    //console.log("el:",el)
    //console.log("el.__vue__:",el.__vue__)
    try{
      let comp=el.__vue__
      if(comp.type==="layout") parent=comp
      //comp=el.__vue__.$children[0].$children[0]
      //if(comp.type==="layout") parent=comp
    }catch(err){}
    if(parent) return parent
    if(el===el.parentNode) break;
    el=el.parentNode
  }
  console.log("parent:",parent)
  return parent;


  console.log("component:",component)
  var el=component.$el.parentNode
  console.log(el)
  while(!el.__vue__){
      el=el.parentNode
  }
  return el.__vue__.$children[0].$children[0]

}
*/

function encodeHTML(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/"/g, '&quot;');
}

function encodeQuotes(str) {
    return String(str).replace(/'/g, '&#39;').replace(/"/g, '&quot;');
}

export function randomNumber(min,max){
    return Math.floor(Math.random()*(max-min+1)+min);
}

//var win = window
export var win = window
